export default "__VITE_ASSET__DygyUZ4J__"